import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@insightai/ui/styles.css'
import { App } from './App'

const container = document.getElementById('root')
if (!container) throw new Error('Root container #root is missing from index.html')

const tree = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)

// Prerendered HTML is hydrated; `pnpm dev` (empty shell) mounts normally.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
